import { Box, Grid } from "@material-ui/core";
import { Form } from "@components";
import React, { useState, useEffect, useCallback, useContext } from "react";
import { useHistory } from "react-router";
import { UPDATE_FILTERS_DATA } from "../state";
import { TableContext } from "../table";
import { Search } from "./search-filters";
import { Actions } from "../../../screens/request/components/actions";

import { createStyles, Theme, WithStyles } from "@material-ui/core/styles";
import { AccessAdminDetail } from "../../../screens/dashboard/admin/maintenance/accessadmin/detail";
import {
  AccessAdminGroupRole,
  AccessAdminForProp,
} from "@api/types/accessadmin";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

interface Props {
  onClickAdd: () => void;
}

export const AccessAdminToolbar: React.FC<Props> = ({}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { dispatch } = useContext(TableContext);
  const [] = React.useState<boolean>(false);
  const [] = React.useState(false);
  const onSearchUpdate = useCallback(
    (term: string) => {
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { searchTerm: term },
      });
    },
    [dispatch]
  );

  useEffect(() => {
    if (!openModal) {
      // clear form if modal has closed
      form.reset();
    }
  }, [openModal]);

  const form = Form.useManager<AccessAdminForProp>({
    id: 0,
    groupName: "",
    emailAddress: "",
  });

  const handleClickOpen = () => {
    setOpenModal(true);
  };

  const isShowModal = openModal ? (
    <AccessAdminDetail
      form={form}
      open={openModal}
      onCancel={() => setOpenModal(false)}
    />
  ) : null;

  return (
    <Box mt={2} mb={2}>
      <Grid container direction="row" spacing={1} justify="space-between">
        <Grid item xs={"auto"}>
          {/* <Actions>
            <Actions.Action onClick={handleClickOpen}>
              + Add New Role
            </Actions.Action>
          </Actions> */}
        </Grid>
        <Grid item xs={3}>
          {/* <Search
            onSearchUpdate={onSearchUpdate}
            placeholder={"Search by Group Role"}
          ></Search> */}
        </Grid>
      </Grid>
      {isShowModal}
    </Box>
  );
};
